var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUnlocked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.49,8.68H8.77V7.27a3.18,3.18,0,0,1,6-1.54l2-.68a5.25,5.25,0,0,0-10,2.22V8.68H5.5a1.85,1.85,0,0,0-1.84,1.84v9.64A1.85,1.85,0,0,0,5.5,22h13a1.85,1.85,0,0,0,1.85-1.84V10.52A1.85,1.85,0,0,0,18.49,8.68Zm-.24,11.23H5.75V10.77h12.5Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,16.71a1.37,1.37,0,1,0-1.37-1.37A1.37,1.37,0,0,0,12,16.71Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUnlocked);
export default __webpack_public_path__ + "static/media/unlocked.3af092017c889473d484242d4dd1a9b8.svg";
export { ForwardRef as ReactComponent };